import { FrontTable } from '@/lib';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getAudiencesTableColumns } from './helpers';
import { DependencyAudience } from './types';

type DependencyAudiencesTableProps = {
  audiences: DependencyAudience[];
  isLoading: boolean;
};
export const DependencyAudiencesTable: FC<DependencyAudiencesTableProps> = ({ audiences, isLoading }) => {
  const { t } = useTranslation();

  const columns = useMemo(() => getAudiencesTableColumns(t), [t]);

  return (
    <FrontTable
      isLoading={isLoading}
      innerWrapperClassName='pb-0 '
      tableData={audiences}
      columns={columns}
      notFound={t('data_source_details:overview.no_audience')}
    />
  );
};
